import React from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import PropTypes from 'prop-types';
import ElementWistiaVideo from '../ElementWistiaVideo';
import styles from './ElementVideo.module.scss';
export const ElementVideoPropTypes = {
  _id: PropTypes.string.isRequired,
  videoId: PropTypes.string,
  isYouTube: PropTypes.bool,
  playsInline: PropTypes.bool
};

function ElementVideo({ _id, videoId, localeVideoIds, isYouTube, playsInline, parent_contentTypeId }) {
  return (
    <div data-testid="ElementVideo" {...sidekick(_id, null, null, 'Element - Video')} className={styles.VideoContainer}> 
      <div className="video-card">
        {videoId || localeVideoIds ? (
          <div data-testid="ElementWistiaVideoWrap" className="card-img-top-wrap">
            <ElementWistiaVideo videoId={videoId} localeVideoIds={localeVideoIds} isYouTube={isYouTube} playsInline={playsInline} parent_contentTypeId={parent_contentTypeId}/>
          </div>
        ) : null}
      </div>
    </div>
  );
}

ElementVideo.propTypes = ElementVideoPropTypes;
ElementVideo.defaultProps = {
  isYouTube: false,
  playsInline: false
};

export default ElementVideo;
